const items = [
  {
    id: 1,
    img: "https://i.ibb.co/p3pcFgV/screencapture-mygame-website-netlify-app-2023-05-03-20-49-18-1.png",
    title: "Gaming Template",
    category: "templates",
    link: "https://mygame-website.netlify.app/",
  },
  {
    id: 17,
    img: "https://i.ibb.co/NpKDMVf/Untitled-1.jpg",
    title: "AL Quran AL Kareem",
    category: "web app",
    link: "https://golden-sfogliatella-bf2ec7.netlify.app/",
  },

  {
    id: 3,
    img: "https://i.ibb.co/WGKGwXL/screencapture-127-0-0-1-5500-index-html-2023-02-23-21-43-03.png",
    title: "Memory Game App",
    category: "games",
    link: "https://memory-game-application-2020.netlify.app/",
  },

  {
    id: 4,
    img: "https://i.ibb.co/8BF8LBq/screencapture-localhost-3000-2023-03-12-13-54-29.png",
    title: "Grocery Bud Application",
    category: "web app",
    link: "https://grocery-bud-application2023.netlify.app/",
  },
  {
    id: 13,
    img: "https://i.ibb.co/HB4mhTQ/hotel.jpg",
    title: "Hotels Reservation Template",
    category: "templates",
    link: "https://website-hotels.netlify.app/",
  },

  {
    id: 5,
    img: "https://i.ibb.co/Kr6NQkS/screencapture-portofolio-modern-netlify-app-2023-02-24-21-12-48.png",
    title: "Portofolio Template",
    category: "templates",
    link: "https://portofolio-modern.netlify.app/",
  },
  {
    id: 2,
    img: "https://i.ibb.co/X7wGthQ/screencapture-mycolors-generator-application-netlify-app-2023-02-24-20-07-39.png",
    title: "Color Generator Application",
    category: "web app",
    link: "https://mycolors-generator-application.netlify.app/",
  },
  {
    id: 8,
    img: "https://i.ibb.co/sJSKjq4/screencapture-awesome-notes-application-netlify-app-2023-02-24-21-00-41.png",
    title: "Take Notes Application",
    category: "web app",
    link: "https://awesome-notes-application.netlify.app/",
  },
  {
    id: 7,
    img: "https://i.ibb.co/0tNDMNW/screencapture-awesome-quiz-application-netlify-app-2023-02-24-20-46-04.png",
    title: "Quiz application",
    category: "web app",
    link: "https://great-weather-application.netlify.app/",
  },

  {
    id: 6,
    img: "https://i.ibb.co/KsgqL2G/screencapture-great-weather-application-netlify-app-2023-02-24-20-44-01.png",
    title: "Weather Application",
    category: "web app",
    link: "https://great-weather-application.netlify.app/",
  },

  {
    id: 9,
    img: "https://i.ibb.co/3zLCZsy/screencapture-awesome-calculator-dark-light-mode-netlify-app-2023-02-24-20-28-05.png",
    title: "Awesome Calculator",
    category: "web app",
    link: "https://awesome-calculator-dark-light-mode.netlify.app/",
  },
  {
    id: 10,
    img: "https://i.ibb.co/CzMCb3R/screencapture-typing-speed-game-app-netlify-app-index-html-2023-02-24-21-15-36.png",
    title: "Typing Speed Game",
    category: "games",
    link: "https://typing-speed-game-app.netlify.app/index.html",
  },
  {
    id: 11,
    img: "https://i.ibb.co/d6JxY27/screencapture-mellow-pithivier-e7e9d8-netlify-app-2023-02-26-13-24-15.png",
    title: "Birthday Notification",
    category: "web app",
    link: "https://mellow-pithivier-e7e9d8.netlify.app/",
  },
  {
    id: 12,
    img: "https://i.ibb.co/KLZSrjr/Untitled-1-Recovered.jpg",
    title: "Awesome Template",
    category: "templates",
    link: "https://modern-site-one.netlify.app/",
  },

  {
    id: 14,
    img: "https://i.ibb.co/1GhZtmL/screencapture-git-hub-repositries-getting-netlify-app-2023-02-24-20-12-57.png",
    title: "Fitch Github Repositries",
    category: "web app",
    link: "https://git-hub-repositries-getting.netlify.app/",
  },
  {
    id: 15,
    img: "https://i.ibb.co/nPkjg5p/screencapture-127-0-0-1-5500-index-html-2023-03-14-21-47-01.png",
    title: "ChatGPT Application",
    category: "web app",
    link: "https://chatgpt-application2023.netlify.app/",
  },
  {
    id: 16,
    img: "https://i.ibb.co/yRjWyW9/screencapture-127-0-0-1-5500-index-html-2023-03-15-22-32-09.png",
    title: "Tic Tac Toe Game",
    category: "games",
    link: "https://tic-tac-toe-game2023.netlify.app/",
  },
];
export default items;
